








































































































































































































































import { Component } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import Alert from '@/components/Shared/Alert.vue';
import ActivityEdit from '@/components/Activities/ActivityEdit.vue';
import ActivityDto from '@/models/Activities/ActivityDto';
import ActivityType, { ActivityTypeLabels, ActivityTypeIcons } from '@/models/Activities/ActivityType';
import ActivityStatus, { ActivityStatusLabels, ActivityStatusColors } from '@/models/Activities/ActivityStatus';
import PageNames from '@/router/PageNames';
import ajax from '@/lib/ajax';
import { AppModule } from '@/store/modules/app';
import OpenEntityInNewWindowBtn from '@/components/Shared/OpenEntityInNewWindowBtn.vue';
import EntityType from '@/models/Shared/EntityType';

@Component({
  name: 'ActivityDetails',
  components: { Alert, ActivityEdit, OpenEntityInNewWindowBtn },
  filters: {
    fallback(value: any, fallbackValue: string) {
      return value || fallbackValue;
    }
  }
})
export default class ActivityDetails extends GiganautVue {
  loading = true;
  activity: ActivityDto | null = null;
  editDialogVisible = false;
  EntityType = EntityType;

  get activityId(): string {
    return this.$route.params.activityid;
  }

  get typeLabel(): string {
    return this.activity ? ActivityTypeLabels[this.activity.activityType] || 'Activity' : 'Activity';
  }

  get typeIcon(): string {
    return this.activity ? ActivityTypeIcons[this.activity.activityType] || this.IconConstants.Activity : this.IconConstants.Activity;
  }

  get typeColor(): string {
    if (!this.activity) return 'grey';
    switch (this.activity.activityType) {
      case ActivityType.Note: return 'grey';
      case ActivityType.Task: return 'orange';
      case ActivityType.InboundCall:
      case ActivityType.OutboundCall: return 'green';
      case ActivityType.Meeting: return 'purple';
      case ActivityType.InboundEmail:
      case ActivityType.OutboundEmail: return 'blue';
      default: return 'grey';
    }
  }

  get statusLabel(): string {
    return this.activity ? ActivityStatusLabels[this.activity.status] || 'Unknown' : '';
  }

  get statusColor(): string {
    return this.activity ? ActivityStatusColors[this.activity.status] || 'grey' : 'grey';
  }

  get isTask(): boolean {
    return this.activity?.activityType === ActivityType.Task;
  }

  get isCall(): boolean {
    return this.activity?.activityType === ActivityType.InboundCall ||
           this.activity?.activityType === ActivityType.OutboundCall;
  }

  get isMeeting(): boolean {
    return this.activity?.activityType === ActivityType.Meeting;
  }

  get isCompleted(): boolean {
    return this.activity?.status === ActivityStatus.Completed;
  }

  get priorityLabel(): string {
    if (!this.activity?.priority) return '-';
    switch (this.activity.priority) {
      case 1: return 'Low';
      case 2: return 'Normal';
      case 3: return 'High';
      case 4: return 'Urgent';
      default: return '-';
    }
  }

  get callResultLabel(): string {
    if (!this.activity?.phoneCallResult) return '-';
    switch (this.activity.phoneCallResult) {
      case 1: return 'Connected';
      case 2: return 'No Answer';
      case 3: return 'Voicemail';
      case 4: return 'Busy';
      case 5: return 'Failed';
      default: return '-';
    }
  }

  async created() {
    await this.loadActivity();
  }

  async loadActivity() {
    this.loading = true;
    try {
      const response = await ajax.get(`/api/v1/agency/activities/${this.activityId}`);
      this.activity = response.data;
    } catch (error) {
      AppModule.handleApiError(error);
    } finally {
      this.loading = false;
    }
  }

  goBack() {
    this.$router.back();
  }

  editActivity() {
    this.editDialogVisible = true;
  }

  async onActivitySaved() {
    this.editDialogVisible = false;
    await this.loadActivity();
  }

  async completeTask() {
    if (!this.activity) return;
    try {
      await ajax.put(`/api/v1/agency/activities/${this.activityId}/status`, {
        status: ActivityStatus.Completed,
        updatedAt: this.activity.updatedAt
      });
      await this.loadActivity();
    } catch (error) {
      AppModule.handleApiError(error);
    }
  }

  formatDuration(seconds: number): string {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return mins > 0 ? `${mins}m ${secs}s` : `${secs}s`;
  }

  navigateToContact() {
    if (this.activity?.contactId) {
      this.$router.push({ name: PageNames.AgencyContactDetails, params: { contactid: this.activity.contactId } });
    }
  }

  navigateToWorker() {
    if (this.activity?.workerId) {
      this.$router.push({ name: PageNames.AgencyWorkerDetails, params: { workerid: this.activity.workerId } });
    }
  }

  navigateToCompany() {
    if (this.activity?.companyId) {
      this.$router.push({ name: PageNames.AgencyCompanyDetails, params: { companyid: this.activity.companyId } });
    }
  }

  navigateToLocation() {
    if (this.activity?.locationId) {
      this.$router.push({ name: PageNames.AgencyLocationDetails, params: { locationid: this.activity.locationId } });
    }
  }
}
